export default __webpack_public_path__ + "static/media/icon_references.8930d80b.svg";